console.log('ip main js loaded');
jQuery(document).ready(function($){
    $('[data-view-tab]').click(function(){
        console.log('clicked');
        var tab = $(this).data('view-tab');
        $('.ip-product-tabs__nav-link').removeClass('active');
        $(this).addClass('active');

        $('.ip-product-tabs__content-item').hide();
        $(`[data-view-tab-content="${tab}"]`).fadeIn();
    });

    $('.ip-faqs__item-title').click(function(){
        $(this).toggleClass('active');
        $(this).next('.ip-faqs__item-content').slideToggle();
    });

    $('.file_link_btn').click(function(event){
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $('#ip-installation-video').offset().top - 100
        }, 1000);
        return false;
    });

    //product_gallery_thumbnails
    var productGalleryThumbnails = new Swiper('.product_gallery_thumbnails', {
        slidesPerView: 'auto',
        spaceBetween: 10,
        breakpoints: {
            0: {
                slidesPerView: 5,
                direction: 'horizontal',
            },
            992: {
                slidesPerView: 'auto',
                direction: 'vertical',
            }
        }
    });

    //product_gallery_main
    var productGalleryMain = new Swiper('.product_gallery_main', {
        slidesPerView: 1,
        spaceBetween: 10,
        autoHeight: true,
        thumbs: {
            swiper: productGalleryThumbnails,
        },
    });

	// product_images_mobile_slider (mobile)
	var productImagesMobileSliderEl = document.getElementById('product_images_mobile_slider');
	if (productImagesMobileSliderEl) {
		var productImagesMobileSlider = new Swiper('#product_images_mobile_slider', {
			slidesPerView: 1,
			spaceBetween: 8,
			loop: false,
			pagination: {
				el: '#product_images_mobile_slider .swiper-pagination',
				clickable: true,
			},
			watchSlidesProgress: true,
			observer: true,
			observeParents: true,
		});
	}
    
    //product_mobile_slider_image
    $('#product_images_mobile_slider_wrapper').magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery: {
            enabled:true
        }
    });
});